import { handleApiErrorResponse } from "../lib/helpers";

export function getCreditSummaryService(formValues,token){
    return fetch(process.env.REACT_APP_API_END_POINT+'researcher/credits/summary?workspace_id='+(formValues && formValues.workspace_id? formValues.workspace_id:''), {
        method: 'GET',
        headers:{"Content-Type":"application/json","Accept":"application/json","Authorization":"Bearer "+token}
    }).then((res)=>{

        const isJson = res.headers.get('content-type')?.includes('application/json');
        const data = isJson ? res.json() : null;

        if (!res.ok) {
            // get error message from body or default to response status
            const error = (data && data.message) || res.status;
            return Promise.reject(error);
        }

        return data;

    }).catch((res)=>{
        handleApiErrorResponse(res);
    });
}
export function getCreditHistoryService(page,transactionOrder, workspace_id,token){
    return fetch(process.env.REACT_APP_API_END_POINT+'researcher/credits/history?workspace_id='+workspace_id+'&page='+page+'&order='+transactionOrder, {
        method: 'GET',
        headers:{"Content-Type":"application/json","Accept":"application/json","Authorization":"Bearer "+token}
    }).then((res)=>{

        const isJson = res.headers.get('content-type')?.includes('application/json');
        const data = isJson ? res.json() : null;

        if (!res.ok) {
            // get error message from body or default to response status
            const error = (data && data.message) || res.status;
            return Promise.reject(error);
        }

        return data;

    }).catch((res)=>{
        handleApiErrorResponse(res);
    });
}
export function buyCreditsService(formValues,token){
    return fetch(process.env.REACT_APP_API_END_POINT+'researcher/credits/buy', {
        method: 'POST',
        body:JSON.stringify(formValues),
        headers:{"Content-Type":"application/json","Accept":"application/json","Authorization":"Bearer "+token}
    })
    .then((res)=>{
        handleApiErrorResponse(res); // check user is authenticate or not
        return res.json()

    } ).catch((res)=>{
        handleApiErrorResponse(res);
    });
}
export function publishCreditsTestService(formValues,token){
    return fetch(process.env.REACT_APP_API_END_POINT+'researcher/credits/test/publish', {
        method: 'POST',
        body:JSON.stringify(formValues),
        headers:{"Content-Type":"application/json","Accept":"application/json","Authorization":"Bearer "+token}
    })
    .then((res)=>{
        handleApiErrorResponse(res); // check user is authenticate or not
        return res.json()

    } ).catch((res)=>{
        handleApiErrorResponse(res);
    });
}
export function makePaymentForTestService(formValues,token){
    return fetch(process.env.REACT_APP_API_END_POINT+'researcher/credits/test/pay', {
        method: 'POST',
        body:JSON.stringify(formValues),
        headers:{"Content-Type":"application/json","Accept":"application/json","Authorization":"Bearer "+token}
    })
    .then((res)=>{
        handleApiErrorResponse(res); // check user is authenticate or not
        return res.json()

    } ).catch((res)=>{
        handleApiErrorResponse(res);
    });
}
export function makePaymentService(formValues,token){
    return fetch(process.env.REACT_APP_API_END_POINT+'researcher/credits/pay', {
        method: 'POST',
        body:JSON.stringify(formValues),
        headers:{"Content-Type":"application/json","Accept":"application/json","Authorization":"Bearer "+token}
    })
    .then((res)=>{
        handleApiErrorResponse(res); // check user is authenticate or not
        return res.json()

    } ).catch((res)=>{
        handleApiErrorResponse(res);
    });
}
export function applyCouponService(formValues,token){
    return fetch(process.env.REACT_APP_API_END_POINT+'researcher/promocodes/apply', {
        method: 'POST',
        body:JSON.stringify(formValues),
        headers:{"Content-Type":"application/json","Accept":"application/json","Authorization":"Bearer "+token}
    }).then((res)=>{

        const isJson = res.headers.get('content-type')?.includes('application/json');
        const data = isJson ? res.json() : null;

        if (!res.ok) {
            // get error message from body or default to response status
            const error = (data && data.message) || res.status;
            return Promise.reject(error);
        }

        return data;

    }).catch((res)=>{
        handleApiErrorResponse(res);
    });
}
export function applyCouponOnTestService(formValues,token){
    return fetch(process.env.REACT_APP_API_END_POINT+'researcher/promocodes/test/apply', {
        method: 'POST',
        body:JSON.stringify(formValues),
        headers:{"Content-Type":"application/json","Accept":"application/json","Authorization":"Bearer "+token}
    }).then((res)=>{

        const isJson = res.headers.get('content-type')?.includes('application/json');
        const data = isJson ? res.json() : null;

        if (!res.ok) {
            // get error message from body or default to response status
            const error = (data && data.message) || res.status;
            return Promise.reject(error);
        }

        return data;

    }).catch((res)=>{
        handleApiErrorResponse(res);
    });
}
export function removeCouponOnTestService(formValues,token){
    return fetch(process.env.REACT_APP_API_END_POINT+'researcher/promocodes/test/remove', {
        method: 'POST',
        body:JSON.stringify(formValues),
        headers:{"Content-Type":"application/json","Accept":"application/json","Authorization":"Bearer "+token}
    }).then((res)=>{

        const isJson = res.headers.get('content-type')?.includes('application/json');
        const data = isJson ? res.json() : null;

        if (!res.ok) {
            // get error message from body or default to response status
            const error = (data && data.message) || res.status;
            return Promise.reject(error);
        }

        return data;

    }).catch((res)=>{
        handleApiErrorResponse(res);
    });
}

export function getTesterCreditSummaryService(token){
    return fetch(process.env.REACT_APP_API_END_POINT+'user/tester/credits/summary', {
        method: 'GET',
        headers:{"Content-Type":"application/json","Accept":"application/json","Authorization":"Bearer "+token}
    }).then((res)=>{

        const isJson = res.headers.get('content-type')?.includes('application/json');
        const data = isJson ? res.json() : null;

        if (!res.ok) {
            // get error message from body or default to response status
            const error = (data && data.message) || res.status;
            return Promise.reject(error);
        }

        return data;

    }).catch((res)=>{
        handleApiErrorResponse(res);
    });
}